import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import InfoModal from "@components/core/modals/InfoModal";

const PhoneNumberCodeInfo: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="pb-8 d-flex justify-content-start">
      <div className="text-left align-items-center">
        <span className="text-left text-primary mr-4">
          {t("contacts.phoneNumberCodeInfo")}
        </span>
        <InfoModal value="phoneNumberCodeInfo" info />
      </div>
    </div>
  );
};

export default PhoneNumberCodeInfo;
